module.exports = __webpack_public_path__ + "img/avalon-top-angle.731789ec.png";